import cx from 'classnames';
import tellerSrc from '../../assets/teller.png';
import teller2xSrc from '../../assets/teller@2x.png';
import styles from './SplashScreen.module.css';
import { useI18n } from '../../i18n';

type SplashScreenProps = {
  visible: boolean;
  message: string;
  progressText?: string | null;
};

export function SplashScreen({
  visible,
  message,
  progressText,
}: SplashScreenProps) {
  const i18n = useI18n();
  return (
    <div className={cx(styles.overlay, !visible && styles.hidden)}>
      <div className={styles.content}>
        <img
          src={tellerSrc}
          srcSet={`${tellerSrc} 1x, ${teller2xSrc} 2x`}
          alt={i18n.splash.loadingAlt}
          className={styles.avatar}
        />
        <span className={styles.label}>{message}</span>
        {progressText ? (
          <span className={styles.progress}>{progressText}</span>
        ) : null}
      </div>
    </div>
  );
}
